import { ref } from 'vue';
import { useStore } from "vuex"
import FeedbackToolbar from "../../FeedbackToolbar/FeedbackToolbar.vue";

export default {
    name: "ChatMessageToolbar",
    components: {
        FeedbackToolbar
    },
    props: {
        messageId: {
            type: Number,
            required: true
        },
        responseId: {
            type: Number,
            required: true
        },
        isAiGenerated: {
            type: Boolean,
            default: false
        },
        labels: {
            type: Object,
        },
        enableFeedbackBar: {
            type: Boolean,
            default: false
        },
        size: {
            type: String,
            default: "medium"
        }
    },
    setup() {
        const store = useStore()
        const feedback = ref(null);

        const handleFeedback = (feedbackPayload) => {
            store.dispatch("aiAssistant/sendMessageFeedback", feedbackPayload);
        };

        return {
            feedback,
            handleFeedback
        };
    }
}